import type {
  WidgetPublicBranding,
  WidgetPublicStats,
} from "@shared/contracts/widgets/public/common";
import { escapeAttr, escapeHtml } from "../utils/escape";
import { formatInteger, formatRating } from "../utils/format";
import type { Translator, WidgetLocale } from "../i18n/resolve";
import { renderStarRating } from "./starRating";

export type HeaderInput = {
  branding: WidgetPublicBranding;
  stats: WidgetPublicStats;
  translate: Translator;
  locale: WidgetLocale;
};

export const renderHeader = ({ branding, stats, translate, locale }: HeaderInput): string => {
  const logo = branding.logoUrl
    ? `<img class="mbn-logo" src="${escapeAttr(branding.logoUrl)}" alt="" />`
    : "";
  const rating =
    stats.averageRating !== null
      ? `<span class="mbn-rating-value">${escapeHtml(
          translate("ratingValue", { value: formatRating(stats.averageRating, locale) }),
        )}</span>`
      : "";
  const stars =
    stats.averageRating !== null ? renderStarRating(stats.averageRating, translate) : "";
  const total = `<span class="mbn-rating-count">${escapeHtml(
    translate("reviewsCount", { count: formatInteger(stats.totalReviews, locale) }),
  )}</span>`;
  const cta = stats.googleUrl
    ? `<a class="mbn-cta" href="${escapeAttr(stats.googleUrl)}" target="_blank" rel="noopener noreferrer">${escapeHtml(
        translate("viewAllReviews"),
      )}</a>`
    : "";
  const name = branding.showEstablishmentName
    ? `<span class="mbn-brand-name">${escapeHtml(branding.establishmentName)}</span>`
    : "";
  return `<header class="mbn-header"><div class="mbn-brand">${logo}${name}</div><div class="mbn-summary">${stars}${rating}${total}</div>${cta}</header>`;
};
